// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-1b7db3a4] {\n  max-height: calc(100vh - 325px) !important;\n}\n.url-cell[data-v-1b7db3a4] {\n  width: 40%;\n  overflow: hidden;\n  word-break: break-word;\n}", ""]);
// Exports
module.exports = exports;
